import type { LevelDef } from '@full-elevator/sim';
import { PAYOUT_BY_STARS, rampedPay } from '@full-elevator/sim';
import level01 from '../levels/01-first-ride.json' with { type: 'json' };
import level02 from '../levels/02-three-stops.json' with { type: 'json' };
import level03 from '../levels/03-lobby-rush.json' with { type: 'json' };
import level04 from '../levels/04-the-long-way.json' with { type: 'json' };
import level05 from '../levels/05-two-directions.json' with { type: 'json' };
import level06 from '../levels/06-tempting-detour.json' with { type: 'json' };
import level07 from '../levels/07-evening-rush.json' with { type: 'json' };
import level08 from '../levels/08-last-call.json' with { type: 'json' };
import level09 from '../levels/09-heavy-load.json' with { type: 'json' };
import level10 from '../levels/10-signature-required.json' with { type: 'json' };
import level11 from '../levels/11-the-executive.json' with { type: 'json' };
import level12 from '../levels/12-together.json' with { type: 'json' };
import level13 from '../levels/13-rush-hour.json' with { type: 'json' };
import level14 from '../levels/14-morning-shift.json' with { type: 'json' };
import level15 from '../levels/15-crossing-shifts.json' with { type: 'json' };
import level16 from '../levels/16-the-convention.json' with { type: 'json' };
import level17 from '../levels/17-lunch-traffic.json' with { type: 'json' };
import level18 from '../levels/18-keep-them-happy.json' with { type: 'json' };
import level19 from '../levels/19-check-in.json' with { type: 'json' };
import level20 from '../levels/20-closing-time.json' with { type: 'json' };
import level21 from '../levels/21-double-shift.json' with { type: 'json' };
import level22 from '../levels/22-hold-the-line.json' with { type: 'json' };
import level23 from '../levels/23-the-executive-floor.json' with { type: 'json' };
import level24 from '../levels/24-the-nine-oclock.json' with { type: 'json' };
import level25 from '../levels/25-full-house.json' with { type: 'json' };
import level26 from '../levels/26-the-tour-group.json' with { type: 'json' };
import level27 from '../levels/27-cafeteria-rush.json' with { type: 'json' };
import level28 from '../levels/28-the-long-shift.json' with { type: 'json' };
import level29 from '../levels/29-everything-at-once.json' with { type: 'json' };
import level30 from '../levels/30-full-elevator.json' with { type: 'json' };
import level31 from '../levels/31-narrow-corridors.json' with { type: 'json' };
import level32 from '../levels/32-late-checkout.json' with { type: 'json' };
import level33 from '../levels/33-turnover.json' with { type: 'json' };
import level34 from '../levels/34-full-house-hotel.json' with { type: 'json' };
import level35 from '../levels/35-two-ways-in.json' with { type: 'json' };
import level36 from '../levels/36-the-last-train.json' with { type: 'json' };
import level37 from '../levels/37-platform-rush.json' with { type: 'json' };
import level38 from '../levels/38-connections.json' with { type: 'json' };
import level39 from '../levels/39-sky-lobby.json' with { type: 'json' };
import level40 from '../levels/40-crossing-the-sixth.json' with { type: 'json' };
import level41 from '../levels/41-the-view.json' with { type: 'json' };
import level42 from '../levels/42-top-to-bottom.json' with { type: 'json' };
import level43 from '../levels/43-code-blue.json' with { type: 'json' };
import level44 from '../levels/44-do-not-disturb.json' with { type: 'json' };
import level45 from '../levels/45-signal-failure.json' with { type: 'json' };
import level46 from '../levels/46-high-alert.json' with { type: 'json' };
import level47 from '../levels/47-the-morning-post.json' with { type: 'json' };
import level48 from '../levels/48-turndown-service.json' with { type: 'json' };
import level49 from '../levels/49-the-605.json' with { type: 'json' };
import level50 from '../levels/50-window-day.json' with { type: 'json' };
import level51 from '../levels/51-the-second-car.json' with { type: 'json' };
import level52 from '../levels/52-rush-both-ways.json' with { type: 'json' };
import level53 from '../levels/53-the-plan.json' with { type: 'json' };
import level54 from '../levels/54-moving-in.json' with { type: 'json' };
import level55 from '../levels/55-heavy-lifting.json' with { type: 'json' };
import level56 from '../levels/56-overtime.json' with { type: 'json' };
import level57 from '../levels/57-quarter-end.json' with { type: 'json' };
import level58 from '../levels/58-the-reshuffle.json' with { type: 'json' };
import level59 from '../levels/59-fire-drill.json' with { type: 'json' };
import level60 from '../levels/60-board-meeting.json' with { type: 'json' };
import level61 from '../levels/61-early-arrivals.json' with { type: 'json' };
import level62 from '../levels/62-breakfast-service.json' with { type: 'json' };
import level63 from '../levels/63-linen-day.json' with { type: 'json' };
import level64 from '../levels/64-the-tour-bus.json' with { type: 'json' };
import level65 from '../levels/65-room-service.json' with { type: 'json' };
import level66 from '../levels/66-pool-hour.json' with { type: 'json' };
import level67 from '../levels/67-the-luggage-cart.json' with { type: 'json' };
import level68 from '../levels/68-wedding-party.json' with { type: 'json' };
import level69 from '../levels/69-the-bellhop.json' with { type: 'json' };
import level70 from '../levels/70-sold-out.json' with { type: 'json' };
import level71 from '../levels/71-afternoon-tea.json' with { type: 'json' };
import level72 from '../levels/72-late-check-in.json' with { type: 'json' };
import level73 from '../levels/73-spa-day.json' with { type: 'json' };
import level74 from '../levels/74-the-gala.json' with { type: 'json' };
import level75 from '../levels/75-fully-booked.json' with { type: 'json' };
import level76 from '../levels/76-rainy-day.json' with { type: 'json' };
import level77 from '../levels/77-noise-complaint.json' with { type: 'json' };
import level78 from '../levels/78-honeymoon-suite.json' with { type: 'json' };
import level79 from '../levels/79-housekeeping-rush.json' with { type: 'json' };
import level80 from '../levels/80-the-conference-wing.json' with { type: 'json' };
import level81 from '../levels/81-midnight-snack.json' with { type: 'json' };
import level82 from '../levels/82-the-trolley-jam.json' with { type: 'json' };
import level83 from '../levels/83-sunday-brunch.json' with { type: 'json' };
import level84 from '../levels/84-jazz-night.json' with { type: 'json' };
import level85 from '../levels/85-grand-reopening.json' with { type: 'json' };
import level86 from '../levels/86-lost-key.json' with { type: 'json' };
import level87 from '../levels/87-the-penthouse.json' with { type: 'json' };
import level88 from '../levels/88-seasons-end.json' with { type: 'json' };
import level89 from '../levels/89-chandelier.json' with { type: 'json' };
import level90 from '../levels/90-high-season.json' with { type: 'json' };
import level91 from '../levels/91-turndown-for-two.json' with { type: 'json' };
import level92 from '../levels/92-last-dance.json' with { type: 'json' };
import level93 from '../levels/93-checkout-chaos.json' with { type: 'json' };
import level94 from '../levels/94-the-grand-finale.json' with { type: 'json' };
import level95 from '../levels/95-first-train.json' with { type: 'json' };
import level96 from '../levels/96-change-here.json' with { type: 'json' };
import level97 from '../levels/97-mind-the-gap.json' with { type: 'json' };
import level98 from '../levels/98-bikes-on-board.json' with { type: 'json' };
import level99 from '../levels/99-ticket-hall.json' with { type: 'json' };
import level100 from '../levels/100-the-express.json' with { type: 'json' };
import level101 from '../levels/101-the-turnstiles.json' with { type: 'json' };
import level102 from '../levels/102-off-peak.json' with { type: 'json' };
import level103 from '../levels/103-heavy-bags.json' with { type: 'json' };
import level104 from '../levels/104-peak-fare.json' with { type: 'json' };
import level105 from '../levels/105-lost-property.json' with { type: 'json' };
import level106 from '../levels/106-football-crowd.json' with { type: 'json' };
import level107 from '../levels/107-the-night-line.json' with { type: 'json' };
import level108 from '../levels/108-strike-day.json' with { type: 'json' };
import level109 from '../levels/109-sunday-service.json' with { type: 'json' };
import level110 from '../levels/110-concert-night.json' with { type: 'json' };
import level111 from '../levels/111-airport-run.json' with { type: 'json' };
import level112 from '../levels/112-man-down.json' with { type: 'json' };
import level113 from '../levels/113-the-sleeper.json' with { type: 'json' };
import level114 from '../levels/114-the-transfer.json' with { type: 'json' };
import level115 from '../levels/115-northbound.json' with { type: 'json' };
import level116 from '../levels/116-southbound.json' with { type: 'json' };
import level117 from '../levels/117-replacement-bus.json' with { type: 'json' };
import level118 from '../levels/118-stopping-service.json' with { type: 'json' };
import level119 from '../levels/119-escalators-out.json' with { type: 'json' };
import level120 from '../levels/120-commuter-belt.json' with { type: 'json' };
import level121 from '../levels/121-season-ticket.json' with { type: 'json' };
import level122 from '../levels/122-gridlock.json' with { type: 'json' };
import level123 from '../levels/123-interchange.json' with { type: 'json' };
import level124 from '../levels/124-last-orders.json' with { type: 'json' };
import level125 from '../levels/125-terminus.json' with { type: 'json' };
import level126 from '../levels/126-the-last-departure.json' with { type: 'json' };
import level127 from '../levels/127-cloud-nine.json' with { type: 'json' };
import level128 from '../levels/128-halfway-up.json' with { type: 'json' };
import level129 from '../levels/129-observation-deck.json' with { type: 'json' };
import level130 from '../levels/130-the-chief-executive.json' with { type: 'json' };
import level131 from '../levels/131-fog-day.json' with { type: 'json' };
import level132 from '../levels/132-the-ascent.json' with { type: 'json' };
import level133 from '../levels/133-lunch-at-the-top.json' with { type: 'json' };
import level134 from '../levels/134-the-sky-shuttle.json' with { type: 'json' };
import level135 from '../levels/135-wind-warning.json' with { type: 'json' };
import level136 from '../levels/136-the-investor.json' with { type: 'json' };
import level137 from '../levels/137-investor-day.json' with { type: 'json' };
import level138 from '../levels/138-the-boardroom.json' with { type: 'json' };
import level139 from '../levels/139-sunrise.json' with { type: 'json' };
import level140 from '../levels/140-rooftop-party.json' with { type: 'json' };
import level141 from '../levels/141-double-height.json' with { type: 'json' };
import level142 from '../levels/142-topping-out.json' with { type: 'json' };
import level143 from '../levels/143-blue-hour.json' with { type: 'json' };
import level144 from '../levels/144-sky-bar.json' with { type: 'json' };
import level145 from '../levels/145-express-to-the-top.json' with { type: 'json' };
import level146 from '../levels/146-code-red.json' with { type: 'json' };
import level147 from '../levels/147-storm-coming.json' with { type: 'json' };
import level148 from '../levels/148-tourist-season.json' with { type: 'json' };
import level149 from '../levels/149-the-transfer-floor.json' with { type: 'json' };
import level150 from '../levels/150-night-shift.json' with { type: 'json' };
import level151 from '../levels/151-the-long-way-up.json' with { type: 'json' };
import level152 from '../levels/152-skyline-gala.json' with { type: 'json' };
import level153 from '../levels/153-glass-floor.json' with { type: 'json' };
import level154 from '../levels/154-cleaning-day.json' with { type: 'json' };
import level155 from '../levels/155-quarter-to-nine.json' with { type: 'json' };
import level156 from '../levels/156-sky-high.json' with { type: 'json' };
import level157 from '../levels/157-all-hands.json' with { type: 'json' };
import level158 from '../levels/158-after-hours.json' with { type: 'json' };
import level159 from '../levels/159-last-light.json' with { type: 'json' };
import level160 from '../levels/160-the-summit.json' with { type: 'json' };
import { parseLevel } from './schema.js';

export { BUILDING_IDS, BUILDINGS, getBuilding, liftFor, rulesFor } from './buildings.js';
export type { RawLevel } from './schema.js';
export { LevelValidationError, levelSchema, parseLevel } from './schema.js';

/**
 * The level set, in play order.
 *
 * Levels 1-7 are the v0.1 core prototype, graded on time. Levels 8-13 are the
 * v0.2 decision prototype, each introducing one passenger rule and graded on the
 * service score, because once passengers differ in urgency and value, time stops
 * capturing whether the right choices were made.
 *
 * The list is explicit rather than glob-loaded so that progression order is data
 * you can read, and so a level cannot silently join the game by existing on disk.
 *
 * Each file is validated at load. That costs about a millisecond and means a
 * broken level can never reach a playtester as mysterious in-game behaviour.
 */
export const LEVELS: readonly LevelDef[] = [
  // office-tower
  level01,
  level02,
  level03,
  level04,
  level08,
  level05,
  level09,
  level06,
  level10,
  level07,
  level11,
  level53,
  level12,
  level47,
  level13,
  level16,
  level15,
  level14,
  level17,
  level18,
  level19,
  level20,
  level54,
  level22,
  level21,
  level26,
  level24,
  level55,
  level25,
  level23,
  level27,
  level56,
  level29,
  level57,
  level28,
  level58,
  level60,
  level59,
  level43,
  level30,
  // grand-hotel
  level31,
  level61,
  level48,
  level32,
  level62,
  level34,
  level64,
  level65,
  level66,
  level63,
  level70,
  level67,
  level68,
  level69,
  level33,
  level75,
  level72,
  level74,
  level71,
  level73,
  level79,
  level78,
  level77,
  level80,
  level76,
  level83,
  level82,
  level81,
  level84,
  level85,
  level87,
  level90,
  level86,
  level89,
  level88,
  level92,
  level93,
  level91,
  level44,
  level94,
  // transit-centre
  level36,
  level35,
  level49,
  level95,
  level37,
  level99,
  level97,
  level98,
  level96,
  level38,
  level103,
  level101,
  level102,
  level104,
  level100,
  level106,
  level51,
  level105,
  level107,
  level108,
  level109,
  level110,
  level111,
  level113,
  level112,
  level117,
  level114,
  level52,
  level115,
  level116,
  level121,
  level119,
  level118,
  level120,
  level122,
  level124,
  level125,
  level123,
  level45,
  level126,
  // skyline-tower
  level127,
  level39,
  level50,
  level40,
  level41,
  level129,
  level128,
  level130,
  level132,
  level131,
  level133,
  level134,
  level135,
  level136,
  level137,
  level140,
  level138,
  level139,
  level141,
  level142,
  level144,
  level143,
  level147,
  level145,
  level146,
  level148,
  level149,
  level152,
  level151,
  level150,
  level157,
  level156,
  level153,
  level154,
  level155,
  level159,
  level42,
  level158,
  level46,
  level160,
]
  .map(parseLevel)
  .map(onTheRamp);

/**
 * A shift's pay by its place in its building (ADR-0042): low at the door,
 * rising to the top. Decided by play order, so it is folded in here, once the
 * whole set is in order, and never by a level file.
 */
function onTheRamp(level: LevelDef, _index: number, all: readonly LevelDef[]): LevelDef {
  const mates = all.filter((l) => l.buildingId === level.buildingId);
  return {
    ...level,
    payout: rampedPay(level.payout ?? PAYOUT_BY_STARS, mates.indexOf(level), mates.length),
  };
}

export const LEVEL_IDS: readonly string[] = LEVELS.map((l) => l.id);

export function getLevel(id: string): LevelDef {
  const level = LEVELS.find((l) => l.id === id);
  if (!level) throw new Error(`Unknown level "${id}". Known: ${LEVEL_IDS.join(', ')}`);
  return level;
}

export function levelIndex(id: string): number {
  return LEVELS.findIndex((l) => l.id === id);
}

/**
 * A shift's number in its own building, from 1: the Grand Hotel's first shift
 * is 1, not 31 (the owner's ask, 2026-10-15). What the player reads; ids and
 * play order are unchanged, so saves and replays are too.
 */
export function shiftInBuilding(id: string): number {
  const index = levelIndex(id);
  const level = LEVELS[index];
  if (!level) return 0;
  return LEVELS.slice(0, index + 1).filter((l) => l.buildingId === level.buildingId).length;
}

/** The next level in play order, or null at the end of the set. */
export function nextLevel(id: string): LevelDef | null {
  const index = levelIndex(id);
  return index === -1 || index + 1 >= LEVELS.length ? null : (LEVELS[index + 1] as LevelDef);
}
